class NexoraShippingProgress extends HTMLElement {
  connectedCallback() {
    this.message = this.closest('[data-announcement]')?.querySelector('[data-nexora-progress-message]');
    this.track = this.querySelector('[data-nexora-progress-track]');
    this.fill = this.querySelector('[data-nexora-progress-fill]');
    this.marker = this.querySelector('[data-nexora-progress-marker]');
    this.primary = Number(this.dataset.primary || 0);
    this.secondary = Number(this.dataset.secondary || this.primary);
    this.country = this.dataset.country || '';
    this.currency = this.dataset.currency || 'EUR';
    if (!this.message || !this.fill || !this.primary) return;
    this.render(Number(this.dataset.initialTotal || 0));
    this.refresh = this.refresh.bind(this);
    this.delayedRefresh = () => window.setTimeout(this.refresh, 180);
    window.addEventListener('pageshow', this.refresh);
    document.addEventListener('change', (event) => {
      if (event.target.closest('cart-drawer, form[action*="/cart"]')) this.delayedRefresh();
    });
    this.connectEventBus(0);
  }
  connectEventBus(attempt) {
    if (window.eventBus && typeof window.eventBus.on === 'function') {
      ['cart:added','update:cart:drawer','render:cart:drawer'].forEach((name) => window.eventBus.on(name, this.delayedRefresh));
    } else if (attempt < 20) {
      window.setTimeout(() => this.connectEventBus(attempt + 1), 250);
    }
  }
  async refresh() {
    if (this.loading) return;
    this.loading = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      if (response.ok) {
        const cart = await response.json();
        this.currency = cart.currency || this.currency;
        this.render(Number(cart.total_price || 0));
      }
    } catch (error) {
      console.warn('Shipping progress could not refresh', error);
    } finally {
      this.loading = false;
    }
  }
  money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: this.currency }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${this.currency}`;
    }
  }
  text(key, amount) {
    const template = this.dataset[key] || '';
    return template.replace('[[amount]]', this.money(Math.max(0, amount || 0)));
  }
  render(total) {
    const ceiling = this.secondary || this.primary;
    const dual = this.secondary > this.primary;
    let copy = '';
    if (dual && total < this.primary) {
      copy = this.text(this.country === 'ES' ? 'esRemainingMainland' : 'ptRemainingMainland', this.primary - total);
    } else if (dual && total < this.secondary) {
      copy = this.text(this.country === 'ES' ? 'esMainlandReached' : 'ptMainlandReached', this.secondary - total);
    } else if (dual) {
      copy = this.text(this.country === 'ES' ? 'esAllReached' : 'ptAllReached');
    } else if (total < this.primary) {
      copy = this.text(this.country === 'PT' ? 'ptRemainingMainland' : 'remaining', this.primary - total);
    } else {
      copy = this.text(this.country === 'PT' ? 'ptMainlandReached' : 'reached');
    }
    const progress = Math.min(100, Math.max(0, (total / ceiling) * 100));
    let state = progress >= 100 ? 'complete' : (progress >= 50 ? 'mid' : 'start');
    if (dual && total >= this.primary && total < this.secondary) state = 'primary-reached';
    this.dataset.state = state;
    this.message.textContent = copy;
    this.fill.style.width = `${progress}%`;
    this.track.setAttribute('aria-valuenow', String(Math.round(progress)));
    if (this.marker) {
      if (dual) {
        this.marker.hidden = false;
        this.marker.style.left = `${(this.primary / this.secondary) * 100}%`;
      } else {
        this.marker.hidden = true;
      }
    }
  }
}
if (!customElements.get('nexora-shipping-progress')) customElements.define('nexora-shipping-progress', NexoraShippingProgress);
